import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { DatePickerField, BaasicFormControls, BaasicButton } from 'core/components';

function ChangeDateModalTemplate({ changeDateModalStore , t}) {
    const {
        form,
        modalParams
    } = changeDateModalStore;

    return (
        <section>
            <form className='form' onSubmit={form.onSubmit}>
                <div className="modal__header">
                    <h4 className="modal__header__title">Move task to another Date</h4>
                </div>
                <div className="modal__body">
                    <div className="form__group">
                        <DatePickerField field={form.$('date')} />
                    </div>
                </div>
                <div className="modal__footer">
                    <BaasicFormControls 
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Change Date"
                    className='btn btn--med btn--primary' 
                    />        
                    <BaasicButton
                        className='btn btn--med btn--light'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => modalParams.close()}
                    />
                </div>
            </form>
        </section> 
    );
    
}

ChangeDateModalTemplate.propTypes = {
    changeDateModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(ChangeDateModalTemplate);
